import type { IPlayer } from "whole-shared";
import { admins } from "whole-shared";

export class Player implements IPlayer {
  displayName = "";
  givenName = "";
  googleId = "";
  id = 0;
  loggedIn = false;
  photo: string | null = null;

  constructor(from?: Partial<Player>) {
    if(from) Object.assign(this, from);
  }

  isAdmin() {
    return admins[this.googleId];
  }

  isLogged() {
    return this.id as unknown as boolean;
  }
}
